
import { KoButton, KoEmpty, KoForm,  KoLoader, KoModal, KoNano, KoTable, KoText, KoTitle, KoToast, KoTooltips } from 'packages';
import KoIcon from '@kwapio/icons';
import React, { useState, useEffect } from 'react';
import { WORKLOG_COLUMNS } from './constant';
import styles from './curd.module.scss';
import WorkLogCrud from './workLogCrud';
// import {DevelopmentAPI } from '../../process/development/development.service';
import { useParams } from 'react-router';
import { getCookie } from 'shared/utils/cookies';
import { ProfileAPI } from 'pages/profile/profile.service';
import { useSelector } from 'react-redux';
import { CurdAPI } from './curd.service';

const WorkLog = ({  isCreateLogOpen, setCreateLog, ticketId, getIssueById, workspaceIdFromParam}) => {
  const [form] = KoForm.useForm();
  const workspaceById = useSelector(state => state?.workspaceById);
  const currentWorkspace = workspaceById['data'];
  const [isLoading, setLoading] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [workLogList, setLogList] = useState();
  const [intervals, setIntervals] = useState();
  const [isOpenSubmit, setOpenSubmit] = useState(false);
  const {workspaceId} = useParams();
  const [conFormdata, setConFormData] = useState();
  const [currentRecord, setCurrentRecord] = useState({
    isBillable: currentWorkspace?.typeofBilling === 'nonBillable' ? false : true
  });
  useEffect(() => {
    getIntervals(workspaceIdFromParam);
    getWorkLogs(ticketId, workspaceId);
  }, [ticketId]);


  const getWorkLogs = (ticketId, workspaceId) => {
    CurdAPI.getWorkLogs(ticketId, workspaceId || workspaceIdFromParam).then(
      (data) => {
        setLogList();
        setLoading(false);
        setCreateLog(false);
        setLogList(data?.workLogs);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getIntervals = (workspaceIdFromParam, values ) => {
    setLoading(true);
    ProfileAPI.getIntervals(workspaceIdFromParam ||workspaceId).then(
      (data) => {
        setLoading(false);
        setIntervals(data?.intervals);
        if(values){
          handleFinish(conFormdata, data?.intervals);
        }
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  
  const handleFinish = ((values, intervalList) => {
    setLoading(true);
    if (!currentRecord?.workLogId) {
      values['workLogId'] = KoNano('WKL');
    }
    if (!currentRecord?.assignee) {
      values['assignee'] = getCookie('userId');
    }
    if(values?.date){
      const ls = intervalList || intervals;
      const matchingInterval = ls.find(interval => {
        const startDate = new Date(interval.startDate);
        const endDate = new Date(interval.endDate);
        return new Date(values?.date) >= startDate && new Date(values?.date) <= endDate;
      });
      values['startDate'] = matchingInterval?.startDate;
      values['endDate'] = matchingInterval?.endDate;
      if(matchingInterval?.status ===1 || matchingInterval?.status ===2 || matchingInterval?.status ===3){
        setConFormData(values);
        values['intervalStart'] = matchingInterval?.intervalStart;
        values['intervalEnd'] = matchingInterval?.intervalEnd;
        setOpenSubmit(true);
        setLoading(false);
        return;
      }else{
        delete values['intervalStart'];
        delete values['intervalEnd'];
      }
    }
    CurdAPI.createOrUpdateWorkLog(values,
      ticketId,
      currentRecord?.workLogId, workspaceId || workspaceIdFromParam).then(
      (data) => {
        setLoading(false);
        setCreateLog(false);
        form.resetFields();
        getWorkLogs(ticketId, workspaceId || workspaceIdFromParam);
        KoToast.success(`Work Log ${currentRecord?.workLogId ? 'updated':'Added'} successfully`);
        getIssueById(ticketId, workspaceIdFromParam);
      },
      (err) => {
        setLoading(false);
      }
    );
  });


  const handleFinishConfirm = () => {
    setLoading(true);
    let data = {
      status: 0
    };
    let q = {
      startDate: conFormdata?.intervalStart,
      endDate: conFormdata?.intervalEnd
    };
   
    ProfileAPI.cancelTimesheet(data, q,  workspaceId || workspaceIdFromParam).then(
      (data) => {
        setLoading(false);
        setCreateLog(false);
        setOpenSubmit(false);
        getIntervals(workspaceId || workspaceIdFromParam, conFormdata);
        KoToast.success(`Timesheet Moved to draft successfully`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const DeleteWorkLog = ()=> {
    setLoading(true);
    CurdAPI.deleteWorkLog(currentRecord?.workLogId,ticketId, workspaceId || workspaceIdFromParam).then(
      (data) => {
        setLoading(false);
        setDeleteModal(false);
        getWorkLogs(ticketId);
        form.resetFields();
        getIssueById(ticketId);
        KoToast.success("Work Log deleted successfully");
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const updateCurrentRecod = (record) => {
    setCurrentRecord(record);
  };


  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 40,
    render: (text, row) => {
      return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => updateCurrentRecod(row)}>
        <KoTooltips title={'Edit'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />} onClick={() => setCreateLog(true)} />
        </KoTooltips>
        <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} onClick={() => setDeleteModal(true)} />
        </KoTooltips>
      </div>;
    }
  }];

  return (
    <div className={styles.curdWrapperChild}>
      { isLoading && <KoLoader />}
      {(!workLogList || workLogList?.length === 0) ?  <KoEmpty width={300} height={200} onClick={() => setCreateLog(true)} title={'Add a Worklog'}
        subText={''} label={'Add Worklog'}
        description={''}/> :
        <div className={`tableCard`}>
          <div className={styles.tableHeader}>
            <KoTitle level={4} text={`Wokrlogs (${workLogList?.length})`} />
            <KoButton type='primary' label='Add Log' onClick={() => {setCreateLog(true); setCurrentRecord({
              isBillable: currentWorkspace?.typeofBilling === 'nonBillable' ? false : true
            });}} />
          </div>
          <KoTable rowKey='ticketId'
            data={{ columns: WORKLOG_COLUMNS, rows: workLogList }}
            extraColumnsRight={columnsRight} maxHeight={100} />
        </div>
      }
     
      <KoModal
        title={currentRecord?.workLogId ? 'Update Log' : 'Add Log'}
        centered
        open={isCreateLogOpen}
        afterClose={() => { setCurrentRecord(); form?.resetFields();}}
        onClose={() => { setCurrentRecord(); setCreateLog(false); form?.resetFields();}}
        width={`35vw`}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setCreateLog(false)} />,
          <KoButton key='add' type='primary' label={currentRecord?.workLogId ? 'Update' : 'Add'} onClick={()=>form.submit()}/>
        ]}>
        <div className={styles.subwrapper}>
          <WorkLogCrud form={form} handleFinish={handleFinish} initialValues={currentRecord}/>
        </div>
      </KoModal>

      <KoModal
        title={`Delete Worklog ${currentRecord?.workLogId?.toUpperCase()}`}
        centered
        open={isOpenDelete}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='delete' loading={isLoading} type='primary' label='Delete Worklog' onClick={() => DeleteWorkLog()} />
        ]}>
        <div className={styles.wrapperModal}>
          <KoTitle level={5} text={`This action will delete item and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>

      <KoModal
        title={`Action Confirmation: Moving worklogs to Draft`}
        centered
        open={isOpenSubmit}
        handleOk={() => { setOpenSubmit(false); }}
        onClose={() => { setOpenSubmit(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => {setOpenSubmit(false); form.setFieldsValue(conFormdata);}} />,
          <KoButton key='confirm' loading={isLoading} type='primary' label='Confirm' onClick={handleFinishConfirm} />
        ]}>
        <div className={styles.wrapperModal}>
          <KoTitle level={5} text={`This action will move your submitted or waiting-for-approval items to the draft. This change cannot be undone.`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>


    </div>
  );
};

export default WorkLog;
